import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const oidcStorage = JSON.parse(
  sessionStorage.getItem(
    `oidc.user:${process.env.REACT_APP_AUTH_URL}:${process.env.REACT_APP_IDENTITY_CLIENT_ID}`
  )
);

const auth = `Bearer ${oidcStorage?.access_token}`;

export const globalDataApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_GLOBAL_DATA_URL}/global-data/`,
    prepareHeaders: headers => {
      if (oidcStorage) headers.set('authorization', auth);
      return headers;
    },
  }),
  endpoints: () => ({}),
  reducerPath: 'globalDataApi',
  refetchOnFocus: false,
});

export default globalDataApi;

export const { usePrefetch } = globalDataApi;
